import React from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "Shared/util/custom-hooks";
import { SettingsCard } from "Shared/components/cards";

type ManualSettingsCardProps = {
    disabled: boolean;
    className?: string;
};

const ManualSettingsCard = ({
    disabled,
    className,
}: ManualSettingsCardProps) => {
    const history = useHistory();
    const t = useTranslation((x) => x.sales_methods.card);

    const handleActionClick = () => history.push("/sales-methods/manual-setup");

    return (
        <SettingsCard
            header={{
                text: t.manually,
            }}
            content={t.manually_description}
            action={
                disabled
                    ? undefined
                    : {
                          svg: "/caret-right.svg",
                          onClick: handleActionClick,
                      }
            }
            className={className || ""}
        />
    );
};

export default ManualSettingsCard;
